<!-- routify:options title='Address details' -->
<!-- routify:options index=3 -->
<!-- routify:options showInNavigation=false -->

<script>
	import { params, goto } from '@sveltech/routify'
	import { onMount } from 'svelte'
    import { fetchJSON } from '../../../common/Backend'
    import { scrollToTop } from '../../../common/Utils'
    import CustomerForm from '../../../components/CustomerForm.svelte'
	import { Notification, ServerErrorNotification, InvalidFieldsNotification } from 'totalinvoice-frontend-core'
    import { Box } from 'totalinvoice-frontend-core'
    import { RefreshButton, BackButton, SaveButton } from 'totalinvoice-frontend-core'
    import { t, languageStore } from 'totalinvoice-frontend-core'
    import { STATUS_NONE, STATUS_LOADING, STATUS_PROCESSING, STATUS_INVALID_FIELDS, STATUS_SERVER_ERROR, STATUS_SUCCESS } from 'totalinvoice-frontend-core'
    import { getCustomerCheckErrors } from "../../../common/Service"

	let status = STATUS_NONE

	let spinSyncButton = true

    let customerForm
    let customerBackup = null

    let showFieldErrors = false
    $: showFieldErrors = status === STATUS_INVALID_FIELDS

    let allFieldsAreValid = false
    let showInvalidFieldsNotification = false
    $: showInvalidFieldsNotification = showFieldErrors && status === STATUS_INVALID_FIELDS

    let error = ''
    let showServerErrorNotification = false
    $: showServerErrorNotification = status === STATUS_SERVER_ERROR

    let showSuccessNotification = false
    $: showSuccessNotification = status === STATUS_SUCCESS

    let checkedErrors = {}

    let updatingCustomer = false
    let deletingCustomer = false

    let customer = null

    onMount(async () => {
        loadData()
    })

	async function loadData() {
		status = STATUS_LOADING
        spinSyncButton = true
		const customerId = $params.id
		if (customerId !== null) {
			const res = await fetchJSON(`customer/${customerId}`)
			if (res.status === 'ok') {
				customer = res.data
                customerBackup = { ...customer }
				status = STATUS_NONE

				// Data is loaded too fast to see the spinning icon of the refresh button,
            	// so we add a short delay to make sure that the user gets a visible feedback.
            	setTimeout(() => spinSyncButton = false, 1000)
			} else {
				error = res
				spinSyncButton = false
				status = STATUS_SERVER_ERROR
			}
		} else {
			spinSyncButton = false
			status = STATUS_NONE
		}
	}

    async function updateCustomer() {
        status = STATUS_PROCESSING
        updatingCustomer = true
        checkedErrors = await getCustomerCheckErrors(customer, $languageStore.selected)
        if (checkedErrors == STATUS_SERVER_ERROR) {
            status = STATUS_SERVER_ERROR
            checkedErrors = {}
        } else {
            if (allFieldsAreValid && Object.keys(checkedErrors).length == 0) {
                const res = await fetchJSON('customer/update', customer)
                if (res.status === 'ok') {
                    status = STATUS_SUCCESS
                } else {
                    error = res
                    status = STATUS_SERVER_ERROR
                }
            } else {
                customerForm.setErrors(checkedErrors)
                status = STATUS_INVALID_FIELDS
            }
        }
        updatingCustomer = false
        scrollToTop()
    }
</script>

<h2 class="title is-2 is-spaced page-title">{$t('Address details')}</h2>

{#if showServerErrorNotification}
    <ServerErrorNotification bind:active={showServerErrorNotification} {error} />
{/if}

{#if showInvalidFieldsNotification}
    <InvalidFieldsNotification bind:active={showInvalidFieldsNotification} errors={checkedErrors} />
{/if}

{#if showSuccessNotification}
    <Notification type='is-success' bind:active={showSuccessNotification} icon={true}>
        <strong>{$t('Address updated successfully.')}</strong>
    </Notification>
{/if}

<div class="buttons">
    <RefreshButton refreshing={spinSyncButton} on:click={() => loadData()} />
</div>

{#if customer !== null}
    <Box title={$t('Address')} icon='fas fa-building'>
        <CustomerForm
            bind:this={customerForm}
            customer={customer}
            editable={true}
            bind:showErrors={showFieldErrors}
            bind:allFieldsAreValid={allFieldsAreValid}
        />
        <div class="buttons is-right mt-5">
            <SaveButton loading={updatingCustomer} on:click={updateCustomer} />
        </div>
    </Box>
{/if}

<div class="buttons mt-6">
    <BackButton on:click={() => $goto('../list')} />
</div>
